export default __webpack_public_path__ + "static/media/dfx-logo-combo-horizontal-light.a3d30aa0.png";